import { render, staticRenderFns } from "./PageLearningUnit.vue?vue&type=template&id=52a7d0b5&"
import script from "./PageLearningUnit.vue?vue&type=script&lang=js&"
export * from "./PageLearningUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports